/**
 * Global menu controller for managing menu state across page transitions
 */
class _MenuController {
  private closeCallback: (() => void) | null = null;
  private isOpenGetter: (() => boolean) | null = null;

  /**
   * Register menu close callback and state tracker
   */
  register(closeCallback: () => void, isOpenGetter: () => boolean): () => void {
    this.closeCallback = closeCallback;
    this.isOpenGetter = isOpenGetter;

    // Return unregister function
    return () => {
      if (this.closeCallback === closeCallback) {
        this.closeCallback = null;
        this.isOpenGetter = null;
      }
    };
  }

  /**
   * Close menu if one is registered and open
   */
  closeMenu(): void {
    if (this.closeCallback) {
      this.closeCallback();
    }
  }

  /**
   * Check if menu controller has a registered menu
   */
  get hasMenu(): boolean {
    return this.closeCallback !== null;
  }

  /**
   * Check if menu is currently open
   */
  get isMenuOpen(): boolean {
    return this.isOpenGetter ? this.isOpenGetter() : false;
  }
}

export const MenuController = new _MenuController();